import { render, staticRenderFns } from "./TheAccountReset.vue?vue&type=template&id=6fd05b17&"
import script from "./TheAccountReset.vue?vue&type=script&lang=js&"
export * from "./TheAccountReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports